import config from "../config";
import { ApiClient } from "./api/apiClient"

export const currenciesService = {
    convertToEur: (amount: number, currency: string) => {
        return ApiClient.currencies_convertToEur(amount, currency, config.appVersion);
    }
}
